import React from 'react'
import './contact.css'
import {AiOutlineMail} from 'react-icons/ai' 
import {AiOutlineWhatsApp} from 'react-icons/ai'

import { useRef } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_5pywymz', 'template_yhe1x0p', form.current, 'V8WLMhVknmnk7h1Zv')

    e.target.reset()
  };


  return (
    <section id='contact'>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
            <AiOutlineMail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>jzn9798@gmail.com</h5>
            <a href="mailto:jzn9798@gmail.com" target='_blank'>Send Email</a>
          </article>

          <article className='contact__option'>
            <AiOutlineWhatsApp className='contact__option-icon' />
            <h4>WhatsApp</h4>
            <h5>+31 0613027372</h5>
          </article>
        </div>

        {/* END OF CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="text" name='email' placeholder='Your Email Address' required />
          <textarea name="message" rows="7" placeholder='Your Message' required ></textarea>
        <button type='submit' className='btn btn-primary'>Send Me Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact